import {useEffect} from 'react';

import eventMessagesService from '@/services/events/eventMessagesService';

/**
 * Reference-counted menu hider.
 *
 * Any component that wants the host menu hidden while it's on screen calls
 * `useHideMenu(active)`. The hook keeps a module-scoped counter of active
 * requests:
 *   - first request (0 -> 1): sends `sendHideMenu`
 *   - last request released (1 -> 0): sends `sendShowMenu`
 *
 * `active` lets callers opt in/out without unmounting (e.g. swiper slides
 * that stay mounted but are not the visible slide).
 */
let hideRequestCount = 0;

const useHideMenu = (active: boolean = true): void => {
    useEffect(() => {
        if (!active) return;

        hideRequestCount++;
        if (hideRequestCount === 1) eventMessagesService.sendHideMenu();

        return () => {
            hideRequestCount--;
            if (hideRequestCount === 0) eventMessagesService.sendShowMenu();
        };
    }, [active]);
};

export default useHideMenu;
